import React, { useEffect, useState } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import { getCustomers, getUsers, getVehicles } from "../../api/apiGetrequest";
import { AddAllocation } from "../../api/apirequest";

const styles = {
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  },
  modalContent: {
    backgroundColor: "white",
    borderRadius: "8px",
    padding: "16px",
    width: "100%",
    maxWidth: "600px",
    maxHeight: "90vh",
    overflowY: "auto",
    position: "relative",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "16px",
  },
  title: {
    fontSize: "20px",
    fontWeight: "bold",
    margin: 0,
  },
  closeButton: {
    background: "none",
    border: "none",
    fontSize: "20px",
    cursor: "pointer",
    color: "#666",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  formGroup: {
    display: "flex",
    flexDirection: "column",
    marginBottom: "10px",
  },
  label: {
    marginBottom: "4px",
    fontSize: "14px",
    fontWeight: "500",
  },
  input: {
    padding: "8px 12px",
    border: "1px solid #ddd",
    borderRadius: "4px",
    fontSize: "14px",
    width: "100%",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    marginTop: "16px",
  },
  button: {
    padding: "8px 16px",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "14px",
    border: "none",
  },
  cancelButton: {
    backgroundColor: "#f0f0f0",
    color: "#333",
  },
  submitButton: {
    backgroundColor: "#007bff",
    color: "white",
  },
  selectStyles: {
    control: (base) => ({
      ...base,
      minHeight: "36px",
      width: "100%",
    }),
    menu: (base) => ({
      ...base,
      maxHeight: "200px",
      overflowY: "auto",
    }),
  },
};

const LoadingPoint = [
  { label: "Embakasi", value: 1 },
  { label: "Nyeri", value: 2 },
  { label: "Molo", value: 3 },
  { label: "Equator", value: 4 },
  { label: "Rift Valley", value: 5 },
  { label: "NBL SUPPLY", value: 6 },
];

const ShipmentFormModal = ({ isOpen, onClose, fetchOrders }) => {
  const [formData, setFormData] = useState({
    driverID: null,
    vehicleID: null,
    customerID: null,
    trip: "",
    tripDate: "",
    shipmentNO: "",
    outletName: "",
    casesFull: 0,
    loadingPointID: 0,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [users, setUsers] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [customers, setCustomers] = useState([]);

  // Set default date to tomorrow
  useEffect(() => {
    const today = new Date();
    today.setDate(today.getDate() + 1);
    const tomorrowDate = today.toISOString().slice(0, 16);
    setFormData((prevData) => ({
      ...prevData,
      tripDate: tomorrowDate,
    }));
    fetchMechanics();
    fetchCustomers();
    fetchVehicles();
  }, []);

  const fetchMechanics = async () => {
    try {
      const result = await getUsers();
      setUsers(result?.filter((m) => m.Role === "driver"));
    } catch (error) {
      toast.error("Failed to fetch mechanics");
    }
  };

  const fetchCustomers = async () => {
    try {
      const result = await getCustomers();
      setCustomers(result);
    } catch (error) {
      toast.error("Failed to fetch customers");
    }
  };

  const fetchVehicles = async () => {
    try {
      const result = await getVehicles();
      setVehicles(
        result?.map((user) => ({
          value: user.VehicleID,
          label: user.VregNO,
          driver: user.UserID,
        }))
      );
    } catch (error) {
      toast.error("Failed to fetch vehicles");
    }
  };

  const validateFormData = (data) => {
    if (!data.driverID) return "Driver ID is required.";
    if (!data.vehicleID) return "Vehicle ID is required.";
    if (!data.customerID) return "Customer ID is required.";
    if (!data.tripDate) return "Trip date is required.";
    if (!data.loadingPointID) return "Loading Point is required.";
    // if (!data.casesFull) return "Number of full cases is required.";
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    const validationError = validateFormData(formData);
    if (validationError) {
      toast.error(validationError);
      setLoading(false);    
      return;
    }

    try {
      const result = await AddAllocation({ ...formData });

      if (result && result.success) {
        toast.success(result.message || "Action successfully completed!");
        fetchOrders();
        onClose();
        setFormData(null)
      } else {
        toast.error(result.message || "An error occurred.");
      }
    } catch (error) {
      console.error("Error during submission:", error);
    } finally {
      setLoading(false);
      setFormData((prevData) => ({
        ...prevData,
        driverID: null,
        vehicleID: null,
      }));
      fetchOrders();
      onClose();
    }
  };

  const driverOptions = users.map((user) => ({
    value: user.UserID,
    label: user.FullName,
  }));

  const customerOptions = customers?.map((c) => {
    return { value: c.CustomerID, label: c.CustomerName };
  });

  const handleDriverChange = (selectedOption) => {
    setFormData({
      ...formData,
      driverID: selectedOption.value,
    });
  };

  const handleVehicleChange = (selectedOption) => {
    setFormData((prevData) => ({
      ...prevData,
      vehicleID: selectedOption.value,
      driverID: selectedOption.driver,
    }));
  };

  if (!isOpen) return null;

  return (
    <div style={styles.modalOverlay}>
      <div style={styles.modalContent} className="modalContent">
        <div style={styles.header}>
          <h2 style={styles.title}>Close Order</h2>
          <button style={styles.closeButton} onClick={onClose}>
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="form">
          <div style={styles.formGroup}>
            <label style={styles.label}>Vehicle*</label>
            <Select
              options={vehicles}
              onChange={handleVehicleChange}
              styles={styles.selectStyles}
              value={vehicles.find(
                (option) => option.value === formData.vehicleID
              )}
            />
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Driver*</label>
            <Select
              options={driverOptions}
              onChange={handleDriverChange}
              styles={styles.selectStyles}
              value={driverOptions.find(
                (option) => option.value === formData.driverID
              )}
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Customer*</label>
            <Select
              options={customerOptions}
              onChange={(option) =>
                setFormData({ ...formData, customerID: option.value })
              }
              styles={styles.selectStyles}
              value={customerOptions.find(
                (option) => option.value === formData.customerID
              )}
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Loading Point*</label>
            <Select
              options={LoadingPoint}
              onChange={(option) =>
                setFormData({ ...formData, loadingPointID: option.value })
              }
              styles={styles.selectStyles}
              value={LoadingPoint.find(
                (option) => option.value === formData.loadingPointID
              )}
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Trip Date*</label>
            <input
              type="datetime-local"
              value={formData.tripDate}
              onChange={(e) =>
                setFormData({ ...formData, tripDate: e.target.value })
              }
              style={styles.input}
            />
          </div>

          <div style={styles.buttonContainer}>
            <button
              type="button"
              onClick={onClose}
              style={{ ...styles.button, ...styles.cancelButton }}
            >
              Cancel
            </button>
            <button
              disabled={loading}
              type="submit"
              style={{
                ...styles.button,
                ...styles.submitButton,
                backgroundColor: loading ? "grey" : "#007bff",
              }}
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ShipmentFormModal;
